/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import Immutable from 'immutable'
import { MenuActionTypes } from '../action/MenuActions'

const MenuState = Immutable.Record({
  isOpen: true,
  isSettingMenuOpen: false
})

class MenuStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MenuState()
  }

  reduce(state, action) {
    switch (action.type) {
      case MenuActionTypes.open:
        return state.merge({ isOpen: true })
      case MenuActionTypes.close:
        return state.merge({ isOpen: false })
      case MenuActionTypes.openSettingMenu:
        return state.merge({ isSettingMenuOpen: true })
      case MenuActionTypes.closeSettingMenu:
        return state.merge({ isSettingMenuOpen: false })
      default:
        return state
    }
  }
}

export default new MenuStore()
